import { authRoles } from 'app/auth';
import i18next from 'i18next';
import Pipeline from './component/pipeline/Pipeline';
// import OptimizationPipeline from './OptimizationPipeline';
import OptimizationPipelineTable from './table/OptimizationPipelineTable';
import OptimizationPipelineEditForm from './editform/OptimizationPipelineEditForm';
import OptimizationPipelineProvider from './component/OptimizationPipelineProvider';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'optimizationPipeline', en);
i18next.addResourceBundle('hu', 'optimizationPipeline', hu);

export default [
	{
		path: '/optimization-pipeline/show/:id',
		component: () => (<OptimizationPipelineProvider><Pipeline />{/* <OptimizationPipeline /> */}</OptimizationPipelineProvider>),
		auth: authRoles.optimizationPipeline
	},
	{
		path: '/optimization-pipeline/edit/:id',
		component: () => (<OptimizationPipelineProvider><OptimizationPipelineEditForm /></OptimizationPipelineProvider>),
		auth: authRoles.optimizationPipeline
	},
	{
		path: '/optimization-pipeline/:sessionNameParam?',
		component: OptimizationPipelineTable,
		auth: authRoles.optimizationPipeline
	},
];
